'use client';

import { useRouter } from 'next/navigation';
import type { ReactNode } from 'react';

export function TypForcedRedirection({ children }: { children: ReactNode }) {
  const router = useRouter();

  const savedTyp = window.sessionStorage.getItem('SAVED_TYP');
  if (savedTyp) {
    router.push(savedTyp);
  } else {
    return children;
  }
}
